import type { TFunction } from 'i18next'
import type { TaskEntryData } from './TaskEntry.types'

/*
  **Der Zeitpunkt einer Zeile als Satz, keine nackte Zahl.**

  „13:53" allein erklärte nicht, was die Zahl bedeutet; im Zweifel hielte man
  sie für eine zweite Dauer. Erledigt und offen sagen dabei Verschiedenes:

  - erledigt → „Geschafft um 13:53 Uhr"
  - offen    → „Zuletzt bearbeitet um 15:30 Uhr"

  **Mit Datum, sobald es nicht heute war.** „um 15:30 Uhr" ohne Tag ist eine
  Lüge, wenn die Aufgabe vorgestern angefasst wurde — und hinter dem
  Geschafft-Schalter eines Projekts liegen Tage durcheinander.

  Leer heißt „kein Tooltip": Eine Aufgabe ohne beide Zeitpunkte bekommt keinen.
  Gebraucht an der Dauer-Marke und an der freien Uhrzeit auf **Geschafft**.
*/
export function timestampTooltip(task: TaskEntryData, locale: string, t: TFunction): string {
  const erledigt = task.completed
  const roh = erledigt ? task.completedAt : task.updatedAt
  if (!roh) return ''
  const wann = roh instanceof Date ? roh : new Date(roh)
  if (Number.isNaN(wann.getTime())) return ''

  const time = wann.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
  const amSelbenTag = wann.toDateString() === new Date().toDateString()
  if (amSelbenTag) {
    return t(erledigt ? 'taskList.completed.at' : 'taskList.lastEditedToday', { time })
  }
  return t(erledigt ? 'taskList.completed.onDay' : 'taskList.lastEditedOnDay', {
    date: wann.toLocaleDateString(locale, { day: 'numeric', month: 'long' }),
    time,
  })
}
